import React from 'react';

import './index.css';

const Analytics = () => {
	return (
		<div>
			<p>Analytics</p>
		</div>
	);
};

export default Analytics;